import React from 'react';
import { Button, Form, Space, Typography } from 'antd';
import { SelectField } from 'Atoms/FormElement';
import { useForm } from 'react-hook-form';
import { useTranslate } from 'Translate';

export default (props) => {
  const { control, handleSubmit } = useForm();
  const i18n = useTranslate();
  const { t } = i18n;

  const onSubmit = (val) => {
    props.onSearch(val);
  };

  return (
    <Space size={15} direction="vertical" className="w-100">
      <Form onFinish={handleSubmit(onSubmit)} layout="inline" className="w-100 inline-form">
        <SelectField
          fieldname="sub_category"
          class="mb-0 w-100 default-select"
          label=""
          control={control}
          iProps={{ placeholder: `${t("Product.family_group")}...` }}
          selectOption={props.field1}
        />
        <Button size="large" type="primary" htmlType="submit">
          {t("General.search")}
        </Button>
      </Form>
    </Space>
  );
};
